import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { BiArrowToTop } from 'react-icons/bi';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <StyledScrollToTop>
      {isVisible && (
        <button onClick={scrollToTop} className="scroll-to-top">
          <BiArrowToTop className="icon" />
        </button>
      )}
    </StyledScrollToTop>
  );
};

export default ScrollToTop;

const StyledScrollToTop = styled.div`
  .scroll-to-top {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${({ theme }) => theme.primary_color};
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    z-index: 1000;

    &:hover {
      background: ${({ theme }) => theme.primary_color_hover || theme.primary_color};
      transform: translateY(-2px);
    }

    .icon {
      font-size: 20px;
    }

    @media (max-width: 768px) {
      bottom: 16px;
      right: 16px;
      width: 36px;
      height: 36px;

      .icon {
        font-size: 18px;
      }
    }

    @media (max-width: 480px) {
      bottom: 12px;
      right: 12px;
      width: 32px;
      height: 32px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

      .icon {
        font-size: 16px;
      }
    }
  }
`;
